<div class="seperator"></div>
<div class="title" mat-dialog-title>Select Partner ID</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">You can select multiple Partner IDs from the below</div>
        <mat-form-field appearance="outline" class="form-field">
            <mat-label>Partner ID</mat-label>
            <mat-select multiple [formControl]="partnerIds">
                <mat-option *ngFor="let profile of data.userProfilesOrAgencies" [value]="profile.profileId">
                    {{profile.profileId + ' - ' + profile.userName}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>
<div class="dialog-footer">
    <div>
        <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()">
            Connect Data Source
        </button>
    </div>
</div>